import { Injectable } from '@angular/core';

import Echo from 'laravel-echo'
import { Channel } from 'laravel-echo/dist/channel'

import { Config } from '../../config/config'

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  protected clienteSocketNaoEncontrado:boolean = false;
  private _config: Config = new Config();

  constructor() {
      if (!this.conectarSocket()) {
          setInterval(() => {
              if (this.clienteSocketNaoEncontrado) {
                  this.conectarSocket()
              }
          }, 5000)
      }
  }

  /**
   * Conectar com o websocket.
   */
  conectarSocket() {
      this.clienteSocketNaoEncontrado = false
      try {
          (<any>window).Echo = new Echo({
              broadcaster: 'socket.io',
              host: `${this._config.get('socketHost')}:${this._config.get('socketPort')}`,
              auth:
                  {
                      headers:
                          {
                              'Authorization': 'Bearer ' + localStorage.getItem('token')
                          }
                  }
          })
      } catch (erro) {
          console.log('😠', 'Erro ao tentar conectar no web socket.')
          this.clienteSocketNaoEncontrado = true
      }
      return this.clienteSocketNaoEncontrado
  }

  public channel(channel:string): Channel {
      if((<any>window).Echo == undefined){
          return;
      }
      return (<any>window).Echo.channel(channel)
  }

  public listen(channel:string, event:string, callback:Function): void {
      if((<any>window).Echo  !== undefined){
        this.channel(channel).listen(event, callback)
      }
  }
}
